import { ReactNode } from 'react';

interface TableDrawerProps {
  title: string;
  eyebrow?: string;
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  wide?: boolean;
}

export default function TableDrawer({ title, eyebrow, isOpen, onClose, children, wide = false }: TableDrawerProps) {
  if (!isOpen) return null;

  return (
    <div className="pointer-events-auto fixed inset-0 z-[55]">
      <button
        type="button"
        className="absolute inset-0 bg-slate-950/18 backdrop-blur-[2px]"
        onClick={onClose}
        aria-label="Close panel"
      />
      <aside className={`table-drawer absolute bottom-0 right-0 top-0 flex w-full flex-col overflow-hidden ${wide ? 'sm:w-[560px]' : 'sm:w-[400px]'}`}>
        <div className="flex items-center justify-between gap-4 border-b border-slate-900/8 px-5 py-4 dark:border-white/8">
          <div className="min-w-0">
            {eyebrow && (
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                {eyebrow}
              </p>
            )}
            <h2 className="truncate text-lg font-semibold text-slate-900 dark:text-slate-100">{title}</h2>
          </div>
          <button type="button" onClick={onClose} className="table-icon-button" aria-label="Close panel">
            ×
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto p-5">{children}</div>
      </aside>
    </div>
  );
}
